import { EMPTY_STRING } from '../Constants';
import { NewAccountFormValues } from './types';

export default function getInitialNewAccountValues(
  defaultValues: Partial<NewAccountFormValues> = {}
) {
  return {
    accountProduct: EMPTY_STRING,
    firstName: EMPTY_STRING,
    middleName: EMPTY_STRING,
    lastName: EMPTY_STRING,
    address1: EMPTY_STRING,
    address2: EMPTY_STRING,
    city: EMPTY_STRING,
    state: EMPTY_STRING,
    zip: EMPTY_STRING,
    ssnLastFour: EMPTY_STRING,
    dateOfBirth: EMPTY_STRING,
    email: EMPTY_STRING,
    primaryPhone: EMPTY_STRING,

    depositSource: EMPTY_STRING,
    amount: undefined,
    ...defaultValues
  };
}
